export default __webpack_public_path__ + "static/media/patterns-no-2.8578d911.ogg";